(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('parent', {
            parent: 'entity',
            url: '/parents',
            title: 'Parents',
            sidebarMeta: {
                icon: 'fa fa-users',
                order: 4
            },
            data: {
                authorities: ['ROLE_RESPONSABLE_INSCRIPTION','ROLE_RESPONSABLE','ROLE_ADMIN'],
                pageTitle: 'josdaviApp.parent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/parent/parents.html',
                    controller: 'ParentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('parent');
                    $translatePartialLoader.addPart('statutArchivage');
                    $translatePartialLoader.addPart('moyenCommunication');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });    }

})();
